/* eslint-disable react/no-array-index-key */
import React from 'react';
import styled from 'styled-components';
import {
  SkeletonLine,
  SkeletonPulse,
} from 'components/theme/Skeleton/Skeleton';

export const ReservationItemListSkeleton: React.FC = () => {
  return (
    <Container>
      {Array.from({ length: 2 }).map((_, i) => (
        <SkeletonReservationItem key={i} />
      ))}
    </Container>
  );
};

const SkeletonReservationItem = () => (
  <Wrapper>
    <ImagePlaceholder />
    <Content>
      <SkeletonLine
        style={{
          width: '20%',
          height: 18,
          marginBottom: 10,
          borderRadius: 4,
        }}
      />
      <SkeletonLine
        style={{
          width: '40%',
          height: 14,
          borderRadius: 4,
        }}
      />
    </Content>
    <StatusWrapper>
      <RadioPlaceholder />
    </StatusWrapper>
  </Wrapper>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 92px;
  border: 0.5px solid var(--way-colors-borderColor);
  display: flex;
  align-items: center;
  flex-direction: row;
`;

const ImagePlaceholder = styled(SkeletonPulse)`
  height: 100%;
  aspect-ratio: 1;
  width: 100px;
  background-size: 400% 400%;
`;

const Content = styled.div`
  padding: 20px;
  width: 100%;
`;

const StatusWrapper = styled.div`
  position: relative;
  display: grid;
  place-content: center;
  padding-right: 20px;
  flex-shrink: 0;
`;

const RadioPlaceholder = styled(SkeletonPulse)`
  width: 18px;
  height: 18px;
  border-radius: 50%;
`;
